module.exports = __webpack_public_path__ + "img/RDC-DRC-Affiliate.e1bf2d5b.jpg";